.page {
  display: flex;
  flex-direction: column;
  gap: 14px;
  max-width: 640px;
  margin: 0 auto;
}

@media (min-width: 720px) {
  .page {
    padding-top: 24px;
  }
}
